import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Copyright from "../component/Copyright";
import { useLocation, useNavigate } from 'react-router-dom';
import { login, sendVCode } from '../lib/api';
import { store } from '../redux/store';
import * as requestAction from "../redux/action/requestAction";

export default function SignIn() {

  const navigate = useNavigate();
  const routerParams = useLocation().state||{};
  // 获取其他组件传过来的参数，并设置到state中
  const [email,setEmail] = React.useState("");  // 一定要有明确的初始值
  const [verifyCode,setVerifyCode] = React.useState("");
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const flag = await login(data);
    if(flag){
      const redirect = routerParams.redirect||"/console";
      navigate(redirect);
    }
  };

  function handleSendCode(){
    if(!email || email.length< 8 || email.indexOf("@") === -1|| email.indexOf(".") === -1){
      store.dispatch(requestAction.warning("请输入正确的邮箱"));
      setEmail("");
      return;
    }
    sendVCode(email);
    store.dispatch(requestAction.info("邮件已发送到："+email+"，请及时查收"));
  }

  React.useEffect(()=>{
    // 如果已经登录，直接进入控制台
    if(store.getState().account.token?.length > 10){
      const redirect = routerParams.redirect||"/console";
      navigate(redirect);
    }
  },[])

  return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            欢迎使用竹米开放平台
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            
            <Grid container spacing={2}>

              <Grid item xs={12}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  type="text"
                  id="text"
                  placeholder='请输入昵称，只能是中文且长度在2~8之间'
                  label="昵称"
                  name="nickname"
                  autoFocus
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  value={email}
                  type={"email"}
                  id="email"
                  placeholder='请务必使用个人邮箱163,qq等'
                  label="个人电子邮箱"
                  onChange={(event)=>{setEmail(event.currentTarget.value)}}
                  name="email"
                />
              </Grid>
           
              <Grid item xs={12} sm={9}>
                <TextField
                  name="verifyCode"
                  required
                  fullWidth
                  autoComplete='off'
                  value={verifyCode}
                  onChange={(event)=>{setVerifyCode(event.currentTarget.value)}}
                  id="verifyCode"
                  label="验证码"
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Button onClick={()=>{handleSendCode()}} variant="contained" size='large' sx={{ mt: 1 }}>发送</Button>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                注册/登录
              </Button>
            </Grid>
           
          </Box>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
  );
}